














































import { CardPinModalVue } from "fs-pb-vue2/vueModels/cardOperations/CardPinModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class CardPinModal extends CardPinModalVue {
  async mounted() {
    await this.init();
  }
}
